import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
// import reportWebVitals from './reportWebVitals'

// Prevent default drop behavior
document.addEventListener('dragover', function(event) {
  event.preventDefault()
})

document.addEventListener('drop', function(event) {
  event.preventDefault()
})

ReactDOM.render(<App />, document.getElementById('root'))
// root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
